import type { FC } from 'react'

import type { AuthorBySlug } from '@/graphql/Author'
import type { getHealthAcademyArticleBySlug } from '@/graphql/HealthAcademyArticle'
import type { AllArticlesByAuthor } from '@/graphql/HealthAcademyArticles'
import type { TopLevelCategory } from '@/graphql/HealthAcademyCategories'

import { ArticlePage } from './Article/ArticlePage'
import { AuthorPage } from './Author/AuthorPage'

export type AcademyArticle = NonNullable<Awaited<ReturnType<typeof getHealthAcademyArticleBySlug>>>
export type AcademyAuthor = NonNullable<AuthorBySlug>
export type AcademyAuthorArticles = AllArticlesByAuthor
export type AcademyCategories = TopLevelCategory[]

// A `/learn/<slug>` page resolves to either an article or an author, never both.
type AcademyContentProps =
  | {
      article: AcademyArticle
      categories: AcademyCategories
    }
  | {
      author: AcademyAuthor
      articles: AcademyAuthorArticles
      categories: AcademyCategories
    }

export const AcademyContent: FC<AcademyContentProps> = (props) => {
  if ('article' in props) {
    return <ArticlePage {...props} />
  }

  if ('author' in props) {
    return <AuthorPage {...props} />
  }

  return null
}
